'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindUIActions = exports.trackUpsellATC = exports.trackUpsellShown = exports.setupUpsellModalContent = undefined;

var _Modal = require('scripts/components/Modal');

var _Helpers = require('scripts/components/Helpers');

var dom = {
  overlay: '[data-overlay]',
  addToCart: '[pdp-atc]',
  upsellAtc: '[data-is-upsell-atc]',
  upsellModalContainer: '[data-modal="upsell"]',
  subscriptionModalContents: '[modal-content="upsell"]',
  upsellImage: '[subscription-upsell-image]',
  upsellProductTitle: '[subscription-upsell-title]',
  upsellProductDesc: '[subscription-upsell-desc]',
  upsellSelectDropdown: '[data-upsell-select-dropdown]',
  upsellSelect: '[data-upsell-select]',
  dropdownContainer: '[data-dropdown]',
  dropdownValue: '[data-dropdown-value]',
  upsellLink: '[upsell-link]'
};

var setupUpsellModalContent = exports.setupUpsellModalContent = function setupUpsellModalContent(productHandle) {
  var handle = productHandle;

  // Any upsell overrides active? (Google Optimize)
  if (window.UPSELL_OVERRIDES && window.UPSELL_OVERRIDES.hasOwnProperty(window.bva.activeProduct.id)) {
    handle = window.UPSELL_OVERRIDES[window.bva.activeProduct.id];
  }

  var resource = 'products/' + handle;
  var templateName = 'upsell';
  var qty = $(dom.addToCart).attr('data-qty') || 1;
  var variantId = $(dom.addToCart).attr('data-variant-id');
  var variantTitle = $(dom.addToCart).attr('data-product-title');
  var isPack = $(dom.addToCart).is('[pack-title]');
  var isUpgrade = Boolean(parseInt($(dom.addToCart).attr('data-upsell-upgrade'), 10));

  (0, _Helpers.getAlternativeTemplate)(resource, templateName).then(function (response) {
    $(dom.subscriptionModalContents).html(response);
    (0, _Modal.show)('upsell');
    $(dom.overlay).addClass('is-no-click overlay--upsell-dark');
    var $upsellModalContainer = $(dom.upsellModalContainer);
    $upsellModalContainer.find('.modal__close').attr('data-toggle-inline-cart', true);
    $upsellModalContainer.find(dom.upsellLink).attr('data-toggle-inline-cart', true);
    $upsellModalContainer.find(dom.upsellAtc).trigger('focus');

    if (handle.indexOf('pack') !== -1) {
      $upsellModalContainer.find(dom.upsellAtc).removeClass('u-hidden');
      $upsellModalContainer.find('.modal__close--link').addClass('u-hidden');
      $upsellModalContainer.find('.js-upsell-title').each(function (index, title) {
        var $title = $(title);
        var titleText = $title.text();
        $title.text(titleText.replace('{scent}', variantTitle));
      });
    }

    if (isUpgrade) $(dom.upsellAtc).removeAttr('add-to-cart').removeAttr('add-pack-to-cart').attr('swap-original-product', true);

    trackUpsellShown(handle);
  });
};

var updateUpsellVariant = function updateUpsellVariant(event) {
  var upsellSelectDropdown = $(dom.upsellSelectDropdown).get(0);
  if (event.detail.container.contains(upsellSelectDropdown)) {
    var $this = $(upsellSelectDropdown);
    var $form = $this.closest('form');
    var $dropdown = $this.closest(dom.dropdownContainer);
    var $value = $dropdown.find(dom.dropdownValue).filter('.is-active');
    var title = $value.text();
    var desc = $value.attr('data-product-desc');
    var variantId = $value.attr('data-dropdown-value');
    var srcset = $value.attr('data-product-image-srcset');

    $(dom.upsellProductTitle).text(title);
    $(dom.upsellProductDesc).html(desc);
    $(dom.upsellSelect).val(variantId);
    $(dom.upsellImage).attr('src', srcset.split(',')[0]).attr('srcset', srcset).attr('data-srcset', srcset);

    var $upsellAtc = $(dom.upsellModalContainer).find(dom.upsellAtc);
    $upsellAtc.attr('data-variant-id', variantId);
  }
};

var triggerUpsellUpdate = function triggerUpsellUpdate(event) {
  var $this = $(event.currentTarget);
  var value = $this.val();
  var $dropdown = $this.closest(dom.dropdownContainer);
  var $dropdownValue = $dropdown.find(dom.dropdownValue).filter('[data-dropdown-value="' + value + '"]');
  $dropdownValue.trigger('click');
};

var trackUpsellShown = exports.trackUpsellShown = function trackUpsellShown() {
  var handle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var isSubscription = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!handle) return;
  window.bva.activeUpsell.handle = handle;
  window.bva.activeUpsell.subscription = isSubscription;
  var upsellType = isSubscription ? 'Subscription' : 'Single';
  dataLayer.push({
    event: 'Upsell Shown',
    upsellProduct: window.bva.activeUpsell.handle,
    upsellType: upsellType
  });
};

var trackUpsellATC = exports.trackUpsellATC = function trackUpsellATC() {
  if (!window.bva.activeUpsell.handle) return;
  var upsellType = window.bva.activeUpsell.subscription ? 'Subscription' : 'Single';
  dataLayer.push({
    event: 'Upsell Added',
    upsellProduct: window.bva.activeUpsell.handle,
    upsellType: upsellType
  });
};

var bindUIActions = exports.bindUIActions = function bindUIActions() {
  document.addEventListener('dropdown.updated', updateUpsellVariant);

  $(document).on('change', dom.upsellSelect, triggerUpsellUpdate);

  $(document).on('click', dom.upsellAtc, trackUpsellATC);
};